module.exports = __webpack_public_path__ + "assets/fde969805f42b1f5d53518c8ced03740.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/buttons/autos/auto_off.mp3
 ** module id = 37
 ** module chunks = 0
 **/